import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { InfoSection, withLayout } from "../../../components";
import { Desktop, NotMobile } from "../../../common/Responsive";
import { MultipleWizardSidebar } from "./wizardSidebar/MultipleWizardSidebar";
import { WizardHeader } from "../wizardHeader/WizardHeader";
import { GoPrevStep } from "../goPrevStepButton/GoPrevStepButton";
import { WizardSteps } from "../../../components/wizardSteps/WizardSteps";

import "../wizardLayout.scss";

const MultipleWizardPageComponent = () => {
  const navigate = useNavigate();

  return (
    <div className="multiple-wizard-page">
      <InfoSection>
        <NotMobile>
          <div>
            <GoPrevStep onClick={() => navigate(-1)} />
          </div>
        </NotMobile>
        <div className="wizard-steps-container">
          <WizardSteps />
        </div>
      </InfoSection>
      <div className="wizard-page__content">
        <Desktop>
          <div className="wizard-page__sidebar">
            <div className="wizard-page__sidebar-container">
              <MultipleWizardSidebar />
            </div>
          </div>
        </Desktop>
        <div className="wizard-page__tabs-content">
          <div className="wizard-page__tabs-content-container">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export const MultipleWizardPage = withLayout({
  customHeader: () => <WizardHeader />,
})(MultipleWizardPageComponent);
